import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import swap from '../../../icons/swap';
import {staggeredReveal} from '../../css/styleSets';
import {setIomoColorTheme, setIomoColorThemeSwapped} from '../iomoSlice';
import {selectIomoColorTheme, selectIomoColorThemeSwapped} from '../iomoSelectors';

@customElement('color-editions-select-item')
export class ColorEditionsSelectItem extends connect(store)(LitElement) {

	@property({type: Object})
	option = {};

	@property({type: String})
	selected = '';

	@property({type: String})
	action = '';

	@property({type: Boolean})
	canBeSelected = true;

	@property({type: Boolean})
	hideDisabled = false;

	static styles = [
		staggeredReveal,
		css`
			:host {
				flex-grow: 1;
				animation-name: fade;
			}

			.item {
				display: flex;
				flex-direction: row;
				position: relative;
				margin-bottom: 0;
				width: 100%;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}
			.item button {
				display: flex;
				flex-direction: row;
				width: 100%;
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: transparent;
				text-align: left;
				height: 48px;
				padding: 0;
				cursor: pointer;
				white-space: nowrap;
				transition: background-color 0.4s, color 0.4s;
				border: 0 none;
			}
			.item button.swap {
				display: none;
			}
			.item button.swappable {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 48px;
				height: 48px;
				background-color: transparent;
			}
			.item button.swappable.selected:hover {
				background-color: var(--color-widget-background-hover);
			}
			.item button.swappable.selected {
				opacity: 0.3;
				pointer-events: none;
			}
			button:hover {
				background-color: var(--color-widget-background-hover);
			}

			.selected button {
				background-color: var(--color-widget-background-selected);
			}

			.fixed button {
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-widget-border);
				pointer-events: none;
			}

			.disabled button:hover {
				color: var(--color-widget-border);
			}

			.disabled.selected button {
				background-color: var(--color-widget-background-selected);
				color: var(--color-widget-background);
			}



			.thumbnail {
				display: flex;
				flex-direction: row;
				background: #f1cba0;
				width: 48px;
				height: 48px;
				aspect-ratio: 1;
				flex-basis: 48px;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}
			.color1 {
				flex-basis: 66%;
				background-color: #999;
			}
			.color2 {
				flex-basis: 34%;
				background-color: #777;
			}

			.label {
				color: var(--color-widget-text);
				font: var(--font-widget-info);
				flex-basis: 100%;
				align-content: center;
				padding: 0 var(--very-small-padding);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.swapped = selectIomoColorThemeSwapped(state);
	}

	isSelected() {
		return this.selected === this.option.id;
	}

	isExcluded() {
		return false;
	}

	isDisabeled() {
		return !this.canBeSelected;
	}

	canBeExcluded() {
		return true;
	}

	async setOption() {
		this.setSwapped(false);
		store.dispatch(setIomoColorTheme({id: this.option.id}));
	}
	setSwapped(value) {
		store.dispatch(setIomoColorThemeSwapped({id: value}));
		console.log('swapped', this.swapped, this.option.swapped);
	}
	toggleSwapped() {
		store.dispatch(setIomoColorThemeSwapped({id: !this.swapped}));
		console.log('swapped', this.swapped, this.option.swapped);
	}
	render() {
		return html`
			<div class="item ${classMap({selected: this.isSelected(), disabled: this.isDisabeled(), hideDisabled: this.hideDisabled, fixed: !this.canBeExcluded()})}">
				<button @click="${this.setOption}">
					<div class="thumbnail">
						<div class="color1" style="background-color: ${this.isSelected() && this.swapped ? this.option.materials?.ring?.color : this.option.materials?.body?.color};"></div>
						<div class="color2" style="background-color: ${this.isSelected() && this.swapped ? this.option.materials?.body?.color : this.option.materials?.ring?.color};"></div>
					</div>
					<div class="label">${this.option.label[this.lang]}</div>
				</button>
				<button class="swap ${classMap({swappable: this.option.swappable, selected: !this.isSelected(), swapped: this.swapped})}" @click="${this.toggleSwapped}">
					<div class="icon">${swap}</div>
				</button>
				${when(this.option.info && this.option.info[this.lang] !== ''  && this.option.info[this.lang] !== '-' && !this.option.info[this.lang]?.startsWith('['), () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.option.info[this.lang]}
						</div>
					</div>
				`)}
			</div>
		`;
	}
}
